const { sameRunStyleInTextBodies } = require('../utils');

exports.computeFontFamilyFromTextBodies = (textBodies, textSelection) => sameRunStyleInTextBodies(textBodies, 'font.family', '', { textSelection });
